// hooks/useAcceptInvite.js
import { useMutation } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const acceptInvite = async ({
  leagueId,
  inviteCode,
  userId,
  getAccessTokenSilently,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL; // Ensure you have this environment variable set
  const token = await getAccessTokenSilently();

  const response = await axios.post(
    `${apiUrl}/api/league/accept-invite`,
    { leagueId, inviteCode, userId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const useAcceptInvite = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useMutation(({ leagueId, inviteCode, userId }) =>
    acceptInvite({ leagueId, inviteCode, userId, getAccessTokenSilently })
  );
};
